export function randomDateWithin(days: number): string {
  const now = Date.now();
  const offset = Math.floor(Math.random() * days) * 24 * 60 * 60 * 1000;
  const date = new Date(now - offset);

  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();

  return `${dd}/${mm}/${yyyy}`;
}

export function generateRandomId(length = 8) {
  return Math.random()
    .toString(36)
    .substring(2, length + 2);
}
